import LeftMenu from '../../AnalyticsModule/Left'
import '../../AnalyticsModule/home.css'
import "../ECI/eciReport.css";
import { useNavigate } from "react-router-dom";
const RoReport = () => {
  let navigate = useNavigate();
  return (
    <LeftMenu>
      <div className="container pl-0 reports">
        <div className="row">
          <div class="col-md-4">
            <div class="card l-bg-cherry">
              <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/ro/report/epb-generation-download-ro-report")}>
                <div class="card-icon card-icon-large"><i class="fas fa-solid fa-envelopes-bulk mr-2"></i></div>
                <div class="row align-items-center mb-2 d-flex">
                  <div class="col-10 card-text-alignment-booked-report">
                    <h5 class="d-flex align-items-center mb-0">
                      e-Postal Ballot Generation/Downloading Report
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card l-bg-grey-dark">
              <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/ro/report/epb-scanning-ro-report")}>
                <div class="card-icon card-icon-large"><i className="fas fa-solid fa-qrcode mr-3"></i></div>
                <div class="row align-items-center mb-2 d-flex">
                  <div class="col-10 card-text-alignment">
                    <h5 class="d-flex align-items-center mb-0">
                      e-Postal Ballot Pre-Counting Report
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card l-bg-orange-dark">
              <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/ro/report/counting-supervisor-ro-report")}>
                <div class="card-icon card-icon-large"><i class="fas fa-solid fa-users-viewfinder mr-3"></i></div>
                <div class="row align-items-center mb-2 d-flex">
                  <div class="col-10 card-text-alignment">
                    <h5 class="d-flex align-items-center mb-0">
                      Counting Supervisor Report
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LeftMenu>
  )
}

export default RoReport
